import React from 'react';
import { ArrowRight, Heart, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
export function Femma() {
  return <div className="container mx-auto px-4 py-12" data-id="element-566">
      <div className="max-w-3xl mx-auto" data-id="element-567">
        {/* Page header */}
        <div className="mb-12" data-id="element-568">
          <h1 className="text-3xl md:text-4xl font-bold uppercase tracking-wide mb-6" data-id="element-569">
            Femma
          </h1>

          {/* Femma logo */}
          <div className="border-2 border-dashed border-gray-300 h-32 w-64 flex items-center justify-center bg-gray-100 rounded-lg mb-8" data-id="element-570">
            <span className="text-gray-400 text-sm" data-id="element-571">Femma logo</span>
          </div>

          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-572">
            De Maekerij is een initiatief van Femma, een van de grootste
            sociaal-culturele vrouwenbewegingen in Vlaanderen. Al meer dan 100
            jaar brengt Femma vrouwen samen en zet ze zich in voor een
            rechtvaardige samenleving.
          </p>
        </div>

        {/* Wat is Femma */}
        <section className="mb-12" data-id="element-573">
          <h2 className="text-2xl font-bold mb-4" data-id="element-574">Wat is Femma?</h2>
          <p className="text-gray-600 leading-relaxed mb-4" data-id="element-575">
            Femma is een beweging van, voor en door vrouwen. Met meer dan 50.000
            leden en honderden lokale afdelingen in heel Vlaanderen is Femma een
            krachtig netwerk dat vrouwen verbindt, versterkt en inspireert.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4" data-id="element-576">
            Femma gelooft in de kracht van ontmoeting en zet zich in voor
            verbinding, gelijkheid en solidariteit. De beweging organiseert
            activiteiten rond vier pijlers: ontmoeting, vorming, cultuur en
            maatschappelijk engagement.
          </p>
          <p className="text-gray-600 leading-relaxed" data-id="element-577">
            Van lokale gespreksavonden tot grote campagnes rond zorgbeleid, van
            creatieve workshops tot internationale solidariteitsprojecten —
            Femma is overal waar vrouwen samen het verschil maken.
          </p>
        </section>

        {/* Femma & De Maekerij */}
        <section className="mb-12" data-id="element-578">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-579">
            <div className="md:w-1/3 border-2 border-dashed border-gray-300 h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0" data-id="element-580">
              <span className="text-gray-400 text-sm" data-id="element-581">Femma × De Maekerij</span>
            </div>
            <div className="md:w-2/3" data-id="element-582">
              <h2 className="text-2xl font-bold mb-4" data-id="element-583">Femma & De Maekerij</h2>
              <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-584">
                Via De Maekerij brengt Femma vrouwen samen rond creativiteit en
                ambacht — een laagdrempelige manier om nieuwe mensen te leren
                kennen en deel uit te maken van een groter verhaal.
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-585">
                De Maekerij vertaalt de missie van Femma naar de praktijk: een
                warme, open plek waar vrouwen kunnen creëren, leren en
                verbinden. Of je nu komt voor een workshop, een kop koffie of
                een gezellige avond in een maekerscafé — je draagt bij aan een
                gemeenschap die verder reikt dan de muren van ons gebouw.
              </p>
            </div>
          </div>
        </section>

        {/* Waarden */}
        <section className="mb-12" data-id="element-586">
          <h2 className="text-2xl font-bold mb-6" data-id="element-587">Waar Femma voor staat</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-588">
            <Card variant="outlined" data-id="element-589">
              <CardContent className="text-center" data-id="element-590">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-591">
                  <Heart size={24} className="text-gray-400" data-id="element-592" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-593">Verbinding</h3>
                <p className="text-sm text-gray-600" data-id="element-594">
                  Vrouwen samenbrengen over generaties, culturen en
                  achtergronden heen. Samen sterker.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-595">
              <CardContent className="text-center" data-id="element-596">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-597">
                  <Heart size={24} className="text-gray-400" data-id="element-598" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-599">Gelijkheid</h3>
                <p className="text-sm text-gray-600" data-id="element-600">
                  Strijden voor gelijke kansen en een rechtvaardige samenleving
                  waarin elke vrouw telt.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-601">
              <CardContent className="text-center" data-id="element-602">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-603">
                  <Heart size={24} className="text-gray-400" data-id="element-604" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-605">Solidariteit</h3>
                <p className="text-sm text-gray-600" data-id="element-606">
                  Lokaal en internationaal opkomen voor vrouwenrechten en
                  sociale rechtvaardigheid.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Lid worden */}
        <section className="mb-12" data-id="element-607">
          <div className="border border-gray-200 rounded-lg p-6 md:p-8 bg-gray-50" data-id="element-608">
            <h2 className="text-xl font-bold mb-3" data-id="element-609">Lid worden van Femma</h2>
            <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-610">
              Als lid van Femma steun je de werking van De Maekerij en de
              bredere beweging. Je krijgt toegang tot extra activiteiten,
              vormingen en voordelen. Lidmaatschap kost slechts een klein bedrag
              per jaar en maakt een groot verschil.
            </p>
            <a href="https://www.femma.be/lid-worden" target="_blank" rel="noopener noreferrer" data-id="element-611">
              <Button variant="primary" size="medium" rightIcon={<ExternalLink size={16} data-id="element-613" />} data-id="element-612">
                Lid worden via femma.be
              </Button>
            </a>
          </div>
        </section>

        {/* Link to Femma website */}
        <section className="mb-8" data-id="element-614">
          <div className="border border-gray-200 rounded-lg p-6 bg-white" data-id="element-615">
            <div className="flex items-start" data-id="element-616">
              <ExternalLink size={20} className="text-gray-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-617" />
              <div data-id="element-618">
                <h3 className="font-bold mb-2" data-id="element-619">Meer over Femma</h3>
                <p className="text-sm text-gray-600 mb-3" data-id="element-620">
                  Wil je meer weten over de geschiedenis, campagnes en
                  activiteiten van Femma? Bezoek de officiële website.
                </p>
                <a href="https://www.femma.be" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-gray-700 hover:underline inline-flex items-center" data-id="element-621">
                  www.femma.be <ExternalLink size={14} className="ml-1" data-id="element-622" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Back link */}
        <div className="text-center" data-id="element-623">
          <Link to="/over-ons" data-id="element-624">
            <Button variant="secondary" size="medium" rightIcon={<ArrowRight size={16} data-id="element-626" />} data-id="element-625">
              Terug naar Over De Maekerij
            </Button>
          </Link>
        </div>
      </div>
    </div>;
}